import React from 'react';
import TopicCard from '../components/TopicCard/TopicCard';
import styles from './Pages.module.css';

const SearchPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Searching </h1>
      <p className={styles.subtitle}></p>
      <div className={styles.cardContainer}>
        <TopicCard
          title="Linear Search"
          description="A simple method that checks each element sequentially."
          link="/search/linear"
          icon="🔍" 
        />
        <TopicCard
          title="Binary Search"
          description="An efficient algorithm for finding an item in a sorted array."
          link="/search/binary"
          icon="🎯"
        />
        <TopicCard
          title="Compare Searches"
          description="See how both algorithms perform on the same dataset."
          link="/search/compare"
          icon="⚖️"
        />
      </div>
    </div>
  );
};

export default SearchPage;